import { createSlice } from "@reduxjs/toolkit";
import { ForgotPasswordState } from "./index.types";

export const initialForgotPasswordState: ForgotPasswordState = {
  forgotPasswordSuccess: null,
  forgotPasswordIsLoading: false,
};

const name = "forgotPassword";

export const forgotPasswordSlice = createSlice({
  name,
  initialState: initialForgotPasswordState,
  reducers: {
    requestForgotPassword: (state) => {
      state.forgotPasswordIsLoading = true;
    },
    clearRequestForgotPassword: (state) => {
      state.forgotPasswordSuccess = null;
      state.forgotPasswordIsLoading = false;
    },
  },
});

export const { requestForgotPassword, clearRequestForgotPassword } = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;

export const userRequestForgotPassword = (data: any) => ({
  payload: {
    apiName: name,
    method: "post",
    data,
    url: `/api/request-password-reset/`,
  },
  type: "requestForgotPassword",
});
